(function () {
  function applyCap() {
    const qtyComponent = document.querySelector('quantity-input');
    const variantInput = document.querySelector('input[name="id"]');

    if (!qtyComponent || !variantInput) return;

    const variantId = variantInput.value;
    if (!variantId) return;

    fetch('/variants/' + variantId + '.js')
      .then(function (r) { return r.json(); })
      .then(function (variant) {
        if (variant.inventory_management !== 'shopify') return;
        // If policy is 'continue', no cap needed
        if (variant.inventory_policy === 'continue') return;

        const max = variant.inventory_quantity;
        if (!max || max <= 0) return;

        const input = qtyComponent.querySelector('input.quantity__input');
        const oldPlus = qtyComponent.querySelector('.quantity__button[name="plus"]');

        if (!input || !oldPlus) return;

        input.setAttribute('max', max);
        if (parseInt(input.value) > max) input.value = max;

        // Clone to remove any previously attached listeners
        const plusBtn = oldPlus.cloneNode(true);
        oldPlus.parentNode.replaceChild(plusBtn, oldPlus);

        // Disable state
        function updateBtn() {
          plusBtn.disabled = parseInt(input.value) >= max;
        }
        updateBtn();

        // Block Dawn's handler in capture phase when at max
        plusBtn.addEventListener('click', function (e) {
          if (parseInt(input.value) >= max) {
            e.preventDefault();
            e.stopImmediatePropagation();
          } else {
            setTimeout(updateBtn, 50);
          }
        }, true);

        // Watch manual input
        input.addEventListener('input', function () {
          if (parseInt(input.value) > max) input.value = max;
          updateBtn();
        });
      });
  }

  // On page load
  window.addEventListener('load', applyCap);

  // On variant switch — Dawn 15 fires 'change' on INPUT
  document.addEventListener('change', function (e) {
    if (
      e.target.tagName === 'INPUT' &&
      e.target.closest('quantity-input')
    ) return; // ignore quantity input changes
    
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') {
      setTimeout(applyCap, 300);
    }
  });

})();
